import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import Image from '../elements/Image';

const propTypes = {
  ...SectionTilesProps.types
};

const defaultProps = {
  ...SectionTilesProps.defaults
};
const News = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {
  const outerClasses = classNames(
    'features-tiles section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-tiles-inner section-inner pt-0',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  return (
    <section {...props} className={outerClasses}>
      <div className='container'>
        <div className={innerClasses}>
          <h2 className='kmo-news-h2'>Latest News</h2>
          <div
            className='hero-figure reveal-from-bottom illustration-element-01'
            data-reveal-value='20px'
            data-reveal-delay='800'
          >
            <a
              href='https://www.bestapp.com/best-apps-to-limit-phone-use/'
              aria-controls='video-modal'
              className='news-img-cont'
              target='_blank'
              rel='noopener noreferrer'
            >
              <Image
                className='has-shadow'
                src={require('./../../assets/images/Apps-to-Curb-Smartphone-Addiction-Badge.webp')}
                alt='Hero'
                width={300}
                height={504}
              />
            </a>
          </div>
          <div className='container-xs center-content'>
            <p className='m-0 mb-32 reveal-from-bottom' data-reveal-delay='400'>
              The Keep Me Out App made it into the
              <br />
              <span style={{ color: 'white' }}>
                "Top 10 Apps to Curb Smartphone Addiction" by BestApp.com
              </span>
              <br /> We are proud to recieve the title "Best for Device
              Locking".
              <a
                href='https://www.bestapp.com/best-apps-to-limit-phone-use/'
                aria-controls='video-modal'
                className='news-img-cont'
                target='_blank'
                rel='noopener noreferrer'
                style={{ marginTop: 20 }}
              >
                Learn More
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

News.propTypes = propTypes;
News.defaultProps = defaultProps;

export default News;
